module.exports = __webpack_public_path__ + "static/media/pic1.cbd7a1e5.jpg";